export default __webpack_public_path__ + "static/media/PrivateEvents3.01bf7b7e.jpg";